import { useEffect } from 'react';

import { prioritizeToothBasisSeries } from '../lib';

export const useToothBasisSeriesPriority = (
  toothID: string,
  isEnabled: boolean,
) => {
  useEffect(() => {
    if (!isEnabled) {
      return;
    }

    prioritizeToothBasisSeries(toothID);

    return () => {
      prioritizeToothBasisSeries('');
    };
  }, [toothID, isEnabled]);
};
